'use client';

import { Stack } from '@andritzot/metris-web-ui/layout/stack';
import { type ReactNode } from 'react';

interface DialogFooterProps {
  children: ReactNode;
}

const DialogFooter = ({ children }: DialogFooterProps) => (
  <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 1 }}>
    {children}
  </Stack>
);

export default DialogFooter;
